module.exports = __webpack_public_path__ + "static/media/paytm.84aa1b56.svg";